module.exports = __webpack_public_path__ + "static/media/400010_02.f346fa99.png";